import React from 'react'
import ReactMarkdown from 'react-markdown'
import { Link } from 'gatsby'

export default function APIRefBlockDefSwagger({ block, parameter }) {
  let xEnum = parameter.x_enum
  let readOnlyVal = parameter.readOnly === true ? <p>Read only.</p> : null
  let defaultVal =
    parameter.defaultValue &&
    parameter.defaultValue !== 'invalid_value_ignore' ? (
      <p>
        Default: <code>{parameter.defaultValue}</code>.
      </p>
    ) : null
  let minLength = parameter.minLength ? (
    <p>
      Minimum length: <code>{parameter.minLength}</code>.
    </p>
  ) : null
  let maxLength = parameter.maxLength ? (
    <p>
      Maximum length: <code>{parameter.maxLength}</code>.
    </p>
  ) : null
  let minimum = parameter.minimum ? (
    <p>
      Minimum value: <code>{parameter.minimum}</code>.
    </p>
  ) : null
  let maximum = parameter.maximum ? (
    <p>
      Maximum value: <code>{parameter.maximum}</code>.
    </p>
  ) : null
  let pattern = parameter.pattern ? (
    <p>
      Pattern: <code>{parameter.pattern}</code>.
    </p>
  ) : null
  //let collectionFormat = (parameter.collectionFormat) ? <p>Collection Format: <code>{parameter.collectionFormat}</code>.</p> : null; DTINTEN-1283

  let enumVal = parameter.enum

  let allowedPossibleValuesList = null
  if (xEnum && xEnum.length > 0) {
    allowedPossibleValuesList = xEnum.map((xenumsingle, index) => {
      return (
        <li key={index}>
          <code className="dax-def-enum-item">{xenumsingle.value}</code>.{' '}
          <span
            className="dax-def-enum-item-description"
            dangerouslySetInnerHTML={{ __html: xenumsingle.description }}
          />
        </li>
      )
    })
  }
  let aOrP = block === 'request' ? 'allowed' : 'possible'
  let aOrPText = <p>The {aOrP} values are:</p>
  let allowedPossibleValuesBlock =
    xEnum && xEnum.length > 0 ? (
      <>
        {aOrPText}
        <ul>{allowedPossibleValuesList}</ul>
      </>
    ) : null
  let aOrPBlock = null
  let aOrPVals = null
  if (enumVal && enumVal.length > 0) {
    // console.log('enumVal', JSON.stringify(enumVal));
    let countVal = 0
    aOrPVals = enumVal.map((singleenum, index) => {
      countVal++
      let separatorChar = countVal !== enumVal.length ? ',' : ''
      return (
        <span key={index}>
          <code>{singleenum}</code>
          {separatorChar}
        </span>
      )
    })
  }
  if (aOrPVals) {
    if (block === 'request') {
      aOrPBlock = <p>Allowed values: {aOrPVals}.</p>
    } else {
      aOrPBlock = <p>Possible values: {aOrPVals}.</p>
    }
  }

  let enumXEnumLinkBlock = null
  if (enumVal || xEnum) {
    enumXEnumLinkBlock = 'enum'
  } else if (parameter.link) {
    enumXEnumLinkBlock = (
      <Link to={`#definition-${parameter.link}`}>{parameter.type}</Link>
    )
  } else {
    let enumXEnumLinkBlockText = null
    if (parameter.linkArray) {
      enumXEnumLinkBlockText = (
        <>
          {' '}
          (contains the{' '}
          <Link to={`#definition-${parameter.linkArray}`}>
            {parameter.linkArray}
          </Link>{' '}
          object)
        </>
      )
    }
    enumXEnumLinkBlock = (
      <>
        {parameter.type}
        {enumXEnumLinkBlockText}
      </>
    )
  }

  let requiredBlock = null
  if (block !== 'response' && parameter.required) {
    requiredBlock = <p className="dax-def-note">required</p>
  }

  return (
    <>
      <div className="dax-def-label" data-type={parameter.type}>
        <h5 className="dax-def-term">
          <code>{parameter.name}</code>
        </h5>

        <p className="dax-def-type">{enumXEnumLinkBlock}</p>

        {requiredBlock}
      </div>

      <div className="dax-def-value">
        <div className="dax-def-detail">
          <ReactMarkdown
            source={parameter.description}
            escapeHtml={false}
            skipHtml={false}
          />
          {allowedPossibleValuesBlock}
        </div>

        <div className="dax-def-meta">
          {readOnlyVal}
          {aOrPBlock}
          {defaultVal}
          {minLength}
          {maxLength}
          {minimum}
          {maximum}
          {pattern}
        </div>
      </div>
    </>
  )
}
